export const SORT_BY_ARTICLE_NUMBER = 'articleNumber';
export const SORT_BY_DELIVERY_WINDOW = 'deliveryWindow';
